import { useContext, useState, useEffect } from "react"

import _ from "lodash"
import { Field } from "formik"

import { FormContext } from "../../../context/formContext"
import { InputMask as Input } from "primereact/inputmask"
import { InputText } from "primereact/inputtext"

import styles from "../../../styles/Form.module.css"

import fieldVisibility from "../../../helpers/fieldVisibility"

export default function ParticipantSSN({ field, block, index }) {
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  const isRequired = checkIfRequired()
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const [hideField, setHideField] = useState(false)

  useEffect(() => {
    const isEditMode = form?.editMode
    const isParticipantProfile = _.endsWith(
      window.location.pathname,
      "profile/"
    )
    const defaultShow = isEditMode || isParticipantProfile
    if (defaultShow) return setHideField(true)
  }, [form])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => {
          if (hideField) {
            if (_.isEmpty(formikField.value)) {
              setHideField(false)
            }
            const handleHiddenValue = () => {
              const split = _.split(formikField.value, "-", 3)
              return `###-###-${split[2] || 4}`
            }
            return (
              <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-eye" onClick={() => setHideField(false)} />
                </span>
                <InputText
                  value={handleHiddenValue()}
                  onClick={() => setHideField(false)}
                  disabled={isDisabled}
                  readOnly
                />
              </div>
            )
          }
          return (
            <>
              <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                  <i className="pi pi-eye-slash" onClick={() => setHideField(true)} />
                </span>
                <Input
                  name={formikField.name}
                  value={formikField.value}
                  onChange={formikField.onChange}
                  disabled={isDisabled}
                  onBlur={() => setHideField(true)}
                  onComplete={() => setHideField(true)}
                  mask="999-99-9999"
                  placeholder="999-99-9999"
                />
              </div>
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )
        }}
      </Field>
    </div>
  )
}
